import React, { useState, useEffect } from 'react';
import Confetti from 'react-confetti'; // <--- IMPORTED CONFETTI
import { db } from '../firebase'; 
import { collection, query, orderBy, onSnapshot } from 'firebase/firestore';
import './Timeline.css';

const Timeline = () => {
  const [memories, setMemories] = useState([]);
  const [loading, setLoading] = useState(true);
  
  // Get window size for confetti to cover the whole screen
  // (Simple version: uses current window size)
  const [windowDimension, setWindowDimension] = useState({ 
    width: window.innerWidth, 
    height: window.innerHeight 
  });

  // Listener to update confetti size if she rotates her phone
  const detectSize = () => {
    setWindowDimension({ width: window.innerWidth, height: window.innerHeight });
  }

  useEffect(() => {
    window.addEventListener('resize', detectSize);

    // Query the 'memories' collection
    const q = query(collection(db, 'memories'), orderBy('date', 'asc'));

    const unsubscribe = onSnapshot(q, (snapshot) => {
      const memoryData = snapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data(),
        date: doc.data().date ? doc.data().date.toDate() : new Date()
      }));
      setMemories(memoryData);
      setLoading(false);
    });

    return () => {
      window.removeEventListener('resize', detectSize);
      unsubscribe();
    };
  }, []);

  if (loading) return <div className="loading-screen">Loading 25 Years of Love...</div>;

  return (
    <div className="timeline-container">
      
      {/* THE CONFETTI EXPLOSION */}
      {/* recycle={false} means it runs once then stops (like a popper) */}
      <Confetti 
        width={windowDimension.width}
        height={windowDimension.height}
        recycle={false} 
        numberOfPieces={500}
        gravity={0.15}
      />

      <header className="hero-section">
        <h1>Happy 25th Birthday!</h1>
        <p>A quarter-century of beautiful moments.</p>
      </header>
      
      <div className="timeline">
        {memories.map((memory, index) => (
          <div key={memory.id} className={`timeline-item ${index % 2 === 0 ? 'left' : 'right'}`}>
            
            <div className="timeline-content">
              <span className="date-badge">
                {memory.date.toLocaleDateString(undefined, { year: 'numeric', month: 'long', day: 'numeric' })}
              </span>

              {memory.imageUrl && (
                <img src={memory.imageUrl} alt={memory.title} className="memory-img" />
              )}
              <h3>{memory.title}</h3>
              <p>{memory.description}</p>
            </div>
            
          </div>
        ))}
      </div>

      <div className="footer-message">
        <p>Here's to the next 25 years... ❤️</p>
      </div>
    </div>
  );
};

export default Timeline;